import { Route } from 'vue-router'
import { Store } from 'vuex'

// resets document title
export default (store: Store<any>) => {
  return (to: Route, from: Route) => {
    if (to.meta && typeof to.meta.pageGroup !== 'undefined') {
      store.dispatch('app/updatePageGroup', to.meta.pageGroup)
    }
  }
}
